/**
 * Whether a level's warm-up has already been offered on this browser.
 *
 * The warm-up opens by itself the first time a level is played and never
 * again: a tutorial that reappears on every visit becomes a thing to dismiss
 * rather than a thing to read. The record is deliberately per browser and not
 * part of progress — it says nothing about what the learner knows, only that
 * the offer has been made, and losing it costs one Esc. Every route out of
 * the overlay writes it, including Skip and Escape, because a learner who
 * closed it has been offered it.
 */

const key = (missionId: string) => `engineeros.warmup.${missionId}`;

/**
 * False whenever storage is unavailable, which makes the offer again rather
 * than swallow it. Private mode is the common case.
 */
export function warmupSeen(missionId: string): boolean {
  try {
    return localStorage.getItem(key(missionId)) === '1';
  } catch {
    return false;
  }
}

export function markWarmupSeen(missionId: string): void {
  try {
    localStorage.setItem(key(missionId), '1');
  } catch {
    /* private mode, or storage disabled */
  }
}
